import React from 'react';
import { ReactComponent as Cancel } from '@assets/svg/icons/logbook/Cancel.svg';
import './index.scss';

type Props = {
  title: string;
  value: string;
  onCancel: (title: string) => void;
};

const Tag: React.FC<Props> = (props: Props) => {
  const { title, value, onCancel } = props;
  return (
    <div className="tag">
      <p>
        {title.toUpperCase()}: {value}
      </p>
      <div onClick={() => onCancel(title)} className="tag-cancel">
        <Cancel />
      </div>
    </div>
  );
};

export default Tag;
